import type { VpnDetailItem } from "../../../types";
import BooleanField from "./BooleanField";
import ComplexBooleanField from "./ComplexBooleanField";
import LabeledField from "./LabeledField";

interface DynamicFieldProps {
  item: VpnDetailItem;
}

function DynamicField({ item }: DynamicFieldProps) {
  if (item.type === "complex_boolean_field") {
    return (
      <ComplexBooleanField
        label={item.label}
        isPositive={item.isPositive}
        hintText={item.hintText}
        yesText={item.yesText}
        noText={item.noText}
      />
    );
  }

  if (item.type === "boolean_field") {
    return (
      <BooleanField
        label={item.label}
        value={item.value}
        yesText={item.yesText}
        noText={item.noText}
      />
    );
  }

  if (item.type === "labeled_field") {
    return <LabeledField label={item.label}>{item.value}</LabeledField>;
  }

  return null;
}

export default DynamicField;
